<template>
  <div>
    <div class="container">
      <div class="headline">
        <h1
          class="h1--underline"
        >
          {{ $tv('headline', 'guidePage') }}
        </h1>
      </div>
      <GuideList
        class="card__container container--guide"
        :guide-list="guides"
        :category="category || undefined"
      />
    </div>
    <NuxtLink
      :to="localePath('/guides')"
      class="k-button k-button-md k-button-solid k-button-solid-base button__category"
    >
      <NavigationChevronLeft class="svg-navigation-chevron-left" />
      <span class="page__button--content">{{ $tv('go-back-button', 'guide') }}</span>
    </NuxtLink>
  </div>
</template>
<script setup lang="ts">
import GuideList from '~/components/guide/GuideList.vue'
import {useGuideService} from '~/composables/guide_service'
import NavigationChevronLeft from '~/assets/icons/navigation_chevron_left.svg?component'
import useBreadcrumb from '~/composables/useBreadcrumb'
import useI18nExtended from '~/composables/usei18nExtended'

const i18n = useI18nExtended()
const params = useRoute()?.params
const {getGuidesByCategory, getGuideCategoryByUrl} = useGuideService()
const nuxtApp = useNuxtApp()
const guides = ref([])
const category = ref(null)

let guideData = nuxtApp.payload?.data[`guides_${i18n.locale.value}_0_-1_null_null_{"field":"guide_categories.Url","operator":"eq","value":"${params.guideCategories}"}_false`]
let categoryData =  (nuxtApp.payload?.data[`guides_${i18n.locale.value}_{"field":"guide_categories.Url","operator":"contains","value":"${params.guideCategories}"}_false`])?.map(g => g.guide_categories).flat()

if (categoryData && params.guideCategories) {
  categoryData = categoryData?.find(n => n.Url.toLowerCase() === params.guideCategories.toLowerCase())
}

if (!categoryData) {
  categoryData = await getGuideCategoryByUrl(params.guideCategories, i18n.locale.value)
}
if (!guideData) {
  guideData = await getGuidesByCategory(params.guideCategories, i18n.locale.value)
}
if (guideData && categoryData) {
  guides.value =  guideData
  category.value = categoryData
} else {
  throw showError({statusCode: 404, statusMessage: 'Page not found for Guide Category: ' + params.guideCategories})
}

useBreadcrumb( [
  {
    label: i18n.te('breadcrumbs.guides') ? i18n.tv('guides', 'breadcrumbs') : i18n.options.name,
    path: '/guides'
  },
  {
    label: i18n.tv(category.value?.Title, 'breadcrumbs'),
    path: `/guides/${encodeURIComponent(category.value?.Url)}`
  }
])

useHead({
  meta: [{hid: 'robots', name: 'robots', content: 'noindex'}]
})

</script>

<style lang="scss">
.headline {
  padding-left: 2rem;
  padding-bottom: 1rem;
  background-color: $color__fst__white;
}

.button__category {
  margin-top: $default-margin-padding-2x;
  margin-bottom: $default-margin-padding-width;
  margin-left: $default-margin-padding-2x;

  .svg-navigation-chevron-left {
    font-size: 1.5rem;
    margin-left: -.3em;
    margin-right: .5em;
  }
}
</style>
